import * as React from "react";
import { Button, Grid } from "semantic-ui-react";
import moment from "moment";

import { useMemo } from "react";
import CountdownTimer from "../CountdownTimer";

interface Props {
  recordingState: "toStart" | "Review" | "Recording" | "Done";
  disabled: boolean;
  doneDisabled: boolean;
  startHandler: () => void;
  stopHandler: () => void;
  startOverHandler: () => void;
  doneHandler: () => void;
  secondsRecorded: number;
}

const dataElmId = "recordActionSection";

const RecordActionSectionFC: React.FC<Props> = ({
  recordingState,
  disabled,
  doneDisabled,
  startHandler,
  stopHandler,
  startOverHandler,
  doneHandler,
  secondsRecorded,
}) => {
  const [showCountdown, setShowCountdown] = React.useState<boolean>(false);

  const isRecording = useMemo(() => {
    return recordingState === "Recording";
  }, [recordingState]);

  const recordingStatusLabel = useMemo(() => {
    return isRecording ? "Recording" : "Stopped";
  }, [isRecording]);

  const recordAction = (): void => {
    switch (recordingState) {
      case "toStart":
        setShowCountdown(true);
        break;
      case "Review":
      case "Done":
        break;
      case "Recording":
        stopHandler();
        break;
    }
  };

  const startOverAction = (): void => {
    startOverHandler();
  };

  const doneRecordingAction = async () => {
    doneHandler();
  };

  const actionButtonLabel = useMemo(() => {
    switch (recordingState) {
      case "toStart":
        return "Start Recording";
      case "Review":
      case "Done":
        return "Re-Record";
      case "Recording":
        return "Stop Recording";
    }
  }, [recordingState]);

  return (
    <>
      {showCountdown && (
        <CountdownTimer
          onFinish={() => {
            setShowCountdown(false);
            startHandler();
          }}
        />
      )}
      <Grid.Column width={8} className="[&_p]:inline-block [&_p]:text-[1.4rem] [&_p]:font-semibold [&_p]:mr-5">
        <Grid.Row centered>
          <p>
            {recordingStatusLabel} - {moment.utc(secondsRecorded * 1000).format("mm:ss")}
          </p>
          {recordingState === "toStart" || recordingState === "Recording" ? (
            <Button disabled={disabled} primary={true} data-elm-id={`${dataElmId}ActionBtn`} onClick={recordAction}>
              {actionButtonLabel}
            </Button>
          ) : (
            <Button
              secondary
              data-elm-id={`${dataElmId}StartOverBtn`}
              className="ml-2.5"
              onClick={startOverAction}
              disabled={isRecording}
            >
              Start Over
            </Button>
          )}
        </Grid.Row>
      </Grid.Column>

      <Grid.Column width={4}>
        {(recordingState === "Review" || recordingState === "Done") && (
          <Button
            primary
            className="float-right text-[1.15em]"
            data-elm-id={`${dataElmId}DoneBtn`}
            disabled={doneDisabled}
            onClick={doneRecordingAction}
          >
            Done Recording!
          </Button>
        )}
      </Grid.Column>
    </>
  );
};

export const RecordActionSection = RecordActionSectionFC;
